import { render, staticRenderFns } from "./DeletePriceOption.vue?vue&type=template&id=69e74f22&"
import script from "./DeletePriceOption.vue?vue&type=script&lang=js&"
export * from "./DeletePriceOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports